export class RiskProfileError extends Error {
  constructor(message) {
    super(message);
    this.ignore = true; // default ignore alert error dialog
  }
}
